var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-old-image" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display == "image",
            expression: "display == 'image'"
          }
        ],
        staticClass: "display-image"
      },
      [
        _c("img", { attrs: { src: _vm.imageSrc, alt: "Event image" } }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "gi-change-image",
            on: {
              click: function($event) {
                return _vm.uploadAnotherImage()
              }
            }
          },
          [_vm._v("Change Image")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display == "dropzone",
            expression: "display == 'dropzone'"
          }
        ],
        class: ["gi-dropzone", _vm.in_progress, { dragover: _vm.dragover }],
        on: {
          click: function($event) {
            return _vm.onClick()
          },
          drop: function($event) {
            $event.preventDefault()
            return _vm.onDrop($event)
          },
          dragover: function($event) {
            $event.preventDefault()
            _vm.dragover = true
          },
          dragleave: function($event) {
            $event.preventDefault()
            _vm.dragover = false
          }
        }
      },
      [
        _c("input", {
          ref: "fileInput",
          attrs: { type: "file", accept: ".jpeg, .jpg, .png" },
          on: {
            change: function($event) {
              return _vm.selectionProcessing($event)
            }
          }
        }),
        _vm._v(" "),
        Object.keys(_vm.processing_errors).length > 0 ||
        _vm.image.status === "INITIATED"
          ? _c(
              "div",
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.processing_errors, function(messages, field) {
                  return Object.keys(_vm.processing_errors).length > 0
                    ? _c("div", { staticClass: "errors" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm._f("unSnakeCase")(_vm._f("capitalize")(field))
                            )
                          )
                        ]),
                        _vm._v(" "),
                        field === "space_limited"
                          ? _c("div", { staticClass: "space_limited_msg" }, [
                              _vm._v(
                                "\n          The file you are trying to upload exceeds the allotted storage.\n          Please clean your "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "/my_storage",
                                    target: "_blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                [_vm._v("Storage")]
                              ),
                              _vm._v(
                                " first before attempting to re-upload\n          it"
                              ),
                              !_vm.is_plus_user
                                ? _c("span", [
                                    _vm._v(", or upgrade to "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "/subscriptions",
                                          target: "_blank"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [_vm._v("Plus account")]
                                    ),
                                    _vm._v(".")
                                  ])
                                : _vm._e()
                            ])
                          : _c(
                              "ul",
                              _vm._l(messages, function(message) {
                                return _c("li", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm._f("capitalize")(message)) +
                                      "\n          "
                                  )
                                ])
                              }),
                              0
                            )
                      ])
                    : _vm._e()
                })
              ],
              2
            )
          : _vm.image.status === "CHECKING"
          ? _c("div", [_vm._v("Checking...")])
          : _vm.image.status === "UPLOADING"
          ? _c("div", [_vm._v(_vm._s(_vm.image.upload_percentage) + "%")])
          : ["COMPLETE"].includes(_vm.image.status)
          ? _c("div", [_vm._v("Complete")])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.display == "cropper",
            expression: "display == 'cropper'"
          }
        ],
        staticClass: "gi-cropper-wrap"
      },
      [
        _c("div", { staticClass: "gim" }, [
          _c("div", { staticClass: "gim-header" }, [
            _c("div", {
              staticClass: "close-btn",
              on: {
                click: function($event) {
                  return _vm.closeCropprModal()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gim-body" },
            [
              _c("p", { staticClass: "bold-txt" }, [_vm._v("Add Sphir Image")]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("vue-cropper", {
                ref: "cropper",
                staticClass: "vue-cropper",
                attrs: {
                  src: _vm.image.url,
                  alt: "Event photo",
                  viewMode: 2,
                  aspectRatio: 1 / 1,
                  minCropBoxWidth: 50,
                  minCropBoxHeight: 50
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bold-txt upload-another",
                  on: {
                    click: function($event) {
                      return _vm.uploadAnotherImage()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-upload" }),
                  _vm._v(" \n          Upload a different image?\n        ")
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "gim-footer" }, [
            _c(
              "div",
              {
                staticClass: "save-btn bold-txt",
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [_vm._v("Set as Sphir Image")]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.image.id,
          expression: "image.id"
        }
      ],
      attrs: { type: "hidden", name: "group[group_image_id]" },
      domProps: { value: _vm.image.id },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.image, "id", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-image-title" }, [
      _c("span", { staticClass: "bold-text" }, [_vm._v("Upload Image")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "To crop image, drag/expand the square as needed. When finished, click "
      ),
      _c("i", [_vm._v("Seat as Sphir Image")]),
      _vm._v(" below")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }